'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'chess-rook';
var width = 384;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M384 192l-48 64 0 112 48 80 0 64-384 0 0-64 48-80 0-112-48-64 0-192 384 0 0 192zM48 461.3l0 2.7 288 0 0-2.7-36.8-61.3-214.4 0-36.8 61.3zM48 176l38.4 51.2 9.6 12.8 0 112 192 0 0-112 9.6-12.8 38.4-51.2 0-128-64 0 0 48-48 0 0-48-64 0 0 48-48 0 0-48-64 0 0 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;